interface UseProductAvailabilityMessageOptions {
  // BlockTopProduct shows nothing while there's no product yet; VProductVariant falls
  // through to the "not available" copy instead. Keep both call sites' current behavior.
  emptyWhenNoProduct?: boolean;
}

// custom_availability isn't declared on Psdata (it's a loosely-typed runtime field), so this
// takes a standalone shape rather than Pick<Psdata, ...> - both still satisfy it structurally.
interface ProductAvailabilityFields {
  custom_availability?: string;
  availability_message?: string;
  availability?: string;
}

export const useProductAvailabilityMessage = (
  product: ComputedRef<ProductAvailabilityFields | null | undefined>,
  options: UseProductAvailabilityMessageOptions = {},
) => {
  const { t } = useI18n();

  return computed(() => {
    if (!product.value && options.emptyWhenNoProduct) return '';
    if (product.value?.custom_availability) return product.value.custom_availability;
    if (product.value?.availability_message) return product.value.availability_message;
    const availability = product.value?.availability?.toLowerCase();
    if (availability === 'available') return t('products.available', 'Available');
    if (availability === 'backorder') return t('products.backorder', 'Available on backorder');
    return t('products.not_available', 'Not available');
  });
};
